export default "__VITE_ASSET__D_IFyMWP__"